// src/subscreens/admin/support/ticketInfo/AdminTicketInfo.jsx
import React from 'react';
import { FiClock, FiCalendar, FiTag, FiFileText } from 'react-icons/fi';
import '../../../../assets/css/admin/subscreens/support/AdminTicketInfo.css';

const AdminTicketInfo = ({ created, updated, category, description }) => {
  return (
    <div className="atv-card admin-ticket-info-card">
      <h3 className="atv-card-title">
        <FiFileText /> Ticket Details
      </h3>

      <div className="admin-ticket-info-grid">
        <div className="admin-ticket-info-item">
          <div className="admin-ticket-info-icon">
            <FiCalendar />
          </div>
          <div>
            <span className="admin-ticket-info-label">Created</span>
            <span className="admin-ticket-info-value">{created}</span>
          </div>
        </div>

        <div className="admin-ticket-info-item">
          <div className="admin-ticket-info-icon">
            <FiClock />
          </div>
          <div>
            <span className="admin-ticket-info-label">Last Updated</span>
            <span className="admin-ticket-info-value">{updated}</span>
          </div>
        </div>

        <div className="admin-ticket-info-item">
          <div className="admin-ticket-info-icon">
            <FiTag />
          </div>
          <div>
            <span className="admin-ticket-info-label">Category</span>
            <span className="admin-ticket-info-value">{category}</span>
          </div>
        </div>
      </div>

      <div className="admin-ticket-description">
        <h4 className="admin-ticket-description-title">Description</h4>
        <p className="admin-ticket-description-text">{description}</p>
      </div>
    </div>
  );
};

export default AdminTicketInfo;